import Vue from 'vue'
import App from './App'
import {
  router
} from './kernel'

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js